// apps/admin-ui/src/routes/_authenticated/coin-transactions/route.tsx
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { CoinTransactionsSearchSchema } from '../../../features/coin-transactions/schema';

// `.catch` гасит невалидные URL (legacy bookmarks, ручная правка search-params)
// и применяет дефолты из Zod-схемы. Pass-through через `parse({})` гарантирует,
// что TanStack Router выводит SEARCH из этой же схемы.
export const Route = createFileRoute('/_authenticated/coin-transactions')({
  staticData: { breadcrumb: 'Энергия' },
  validateSearch: CoinTransactionsSearchSchema.catch(CoinTransactionsSearchSchema.parse({})),
  component: () => <Outlet />,
});
